<span class="agent-streaming-cursor" aria-hidden="true"></span>
